<template>
  <div class="bgwithe">
    <el-container>
      <el-main>
        <div class="box">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input v-model.trim="inputNum" placeholder="请输入卡号" />
            </el-form-item>
            <el-form-item>
              <el-input v-model.trim="imei" placeholder="请输入IMEI号" />

            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="danger_level" placeholder="风险等级" style="width: 200px">
                <el-option :value="0" label="低危" />
                <el-option :value="1" label="高危" />
                <el-option :value="2" label="未识别" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker style="padding-left:3px" v-model="selectDatetimest" type="datetime" placeholder="选择开始时间" @change="dataSearchSt" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="selectDatetimeed" type="datetime" placeholder="选择结束时间" @change="dataSearchEd" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-form>
          <label style="padding-left: 3px;">
            <el-button size="small" @click="list(1)" type="primary" icon="el-icon-search">搜索</el-button>
            <!--<el-button size="small" @click="download" type="success" icon="el-icon-download">导出</el-button>-->
          </label>
        </div>

        <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}" :cell-style="{height:'5px,0',textAlign:'center'}" :max-height="maxHeight" :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" border style="width: 100%;margin-top: 1%">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="cardDefineNo" label="卡号" width="200">
          </el-table-column>
          <el-table-column prop="imei" label="IMEI号" width="170">
          </el-table-column>
          <el-table-column prop="dangerLevel" label="风险等级" min-width="100%">
          </el-table-column>
          <el-table-column prop="dangerDesc" label="风险描述" min-width="100%">
          </el-table-column>
          <el-table-column prop="brand" label="品牌" width="370">
          </el-table-column>
          <el-table-column prop="brandType" label="类型" min-width="100%">
          </el-table-column>

          <el-table-column prop="cardType" label="通道" min-width="100%">
          </el-table-column>
          <el-table-column width="200" prop="createTime" label="查询时间">
          </el-table-column>
        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'apiLogs',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
  },

  data() {
    return {
      maxHeight: 500,
      imei: '',
      danger_level: '',
      agentBe: '',
      oneCardType: '',
      agents: [],
      agent: '',
      ordType: '',
      payType: '',
      agentId: '',
      parentId: '',
      validateType: '',
      dialogFormVisible: false,
      multipleSelection: [],
      options: [],
      cardType: '',
      tableData: [],
      inputNum: '',
      inputNumber: '',
      cards: {},
      type: '',
      isDisabled: true,
      cardTypeList: [],
      iccids: '',
      status: '',
      selectDatetimest: '',
      selectDatetimeed: '',
      riskJs:require('../../../api/risk')
    }
  },

  methods: {
    dataSearchSt(data) {
      this.startTime=data
    },
    dataSearchEd(data) {
      this.endTime=data
    },

    //导出的方法
    exportExcel() {
      let _this = this
      window.open(process.env.VUE_APP_SERVER + '/system/order/exportSucOrder?number=' + _this.inputNum + '&ordType=' + _this.ordType + '&agentId=' + _this.agent + '&ordNo=' + _this.inputNumber + '&selectDatetimest=' + _this.selectDatetimeed + '&selectDatetimeed=' + _this.selectDatetimest)
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      if (_this.selectDatetimeed === null) {
        _this.selectDatetimeed = ''
      }
      if (_this.selectDatetimest === null) {
        _this.selectDatetimest = ''
      }
      let data={
          current: page,
          size: _this.$refs.pagination.size,
          number: _this.inputNum,
          imei: _this.imei,
          dangerLevel: _this.danger_level,
          endTime: _this.selectDatetimeed,
          startTime: _this.selectDatetimest
      }
      _this.riskJs.queryList(data)
        .then(response => {
          _this.tableData = response.data.data.rows
          console.log(sessionStorage.getItem('token'))
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },
    download() {
      let _this = this
      window.location.href = process.env.VUE_APP_SERVER + '/system/imei-contro/downloadfile?number=' + _this.inputNum + '&imei=' + _this.imei + '&danger_level=' + _this.danger_level + '&selectDatetimeed=' + _this.selectDatetimeed + '&selectDatetimest' + _this.selectDatetimest
    }
  }
}
</script>

<style>
.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
</style>
<style scoped>
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
/deep/ ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 5px 0px 5px #f0f0f0;
  background: #d9d9d9;
}
/deep/ ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
}
</style>